import React, {useEffect,useState} from 'react';
import { Image, Text, Group, Button } from '@mantine/core';
import { modals } from '@mantine/modals';

export function GridPage({
  SelectedPageCreateTests,
  SelectedThumbnail,
  SelectedThumbnailChange,
  SelectedDraftThumbnail,
  SelectedDraftThumbnailChange,
  DraftThumbnailIsSelected,
  DraftThumbnailIsSelectedChange,
  ThumbnailIsSelected,
  ThumbnailIsSelectedChange,
  SelectedDraftPageIdChange,
  SelectedDraftTaguchiIdChange,
  setActiveTestsId,
  setActiveFunnelId,
  setIsActiveTestSelected
  }:any) {

  const [selectedPageMsg, setSelectedPageMsg] = useState("");
  const handleDraftThumbnailClick = (pageId,taguchiTestId,funnelId,testsId) => {
    if (DraftThumbnailIsSelected && SelectedDraftThumbnail === pageId) {
      SelectedDraftThumbnailChange(null);
      DraftThumbnailIsSelectedChange(false);
    } else {
      SelectedThumbnailChange(null);  
      SelectedDraftThumbnailChange(pageId);
      DraftThumbnailIsSelectedChange(true);
      SelectedDraftPageIdChange(pageId);
      SelectedDraftTaguchiIdChange(taguchiTestId);
    }
  };

  const handleThumbnailClick = (pageId,taguchiTestId,funnelId,testsId,pageClass) => {
    if (ThumbnailIsSelected && SelectedThumbnail === pageId) {
      SelectedThumbnailChange(null);
      ThumbnailIsSelectedChange(false);
    } else {
      SelectedThumbnailChange(pageId);
      ThumbnailIsSelectedChange(true);
      SelectedDraftThumbnailChange(null);  
      SelectedDraftTaguchiIdChange(taguchiTestId);
      setActiveTestsId(testsId);
      setActiveFunnelId(funnelId);
      if(pageClass === "page active"){
        setIsActiveTestSelected(true);
      }
    }
  };

  useEffect(() => {
    if (selectedPageMsg !== "") {
      modals.open({
        trapFocus: false,
        title: 'Message',
        children: (
        <>
          <Text size="sm" style={{ whiteSpace: "pre-line" }}>
            {selectedPageMsg.trim()}
          </Text>
          <Group position="right" mt="sm">
            <Button onClick={() => {modals.closeAll();setSelectedPageMsg("");}}>OK</Button>
          </Group>
        </>
        ),
      });
      return;
    }
  }, [selectedPageMsg]);

  return (
    <>    
      {SelectedPageCreateTests.map((item, index) => (
        <div className="visi-page" key={index} style={{marginRight:10}} >
          <div className={item.pageClass}
                style={{ cursor: 'pointer', backgroundColor: (item.selected || SelectedThumbnail === item.page_id || SelectedDraftThumbnail === item.page_id) ? '#00b975' : '', userSelect: 'none' }}
                onClick={item.selected ? undefined : () => {
                  if (item.pageClass === "page draft") {
                      handleDraftThumbnailClick(item.page_id, item.taguchi_test_id, item.funnel_id, item.tests_id);
                  }else if(item.pageClass === "page winner" && !Number(item.winner_base)) {
                      // winner_base: the winner is the page's current version, so a new test starts on top of it.
                      setSelectedPageMsg("This page already has a winner.");
                  }else if(item.pageClass === "page rotation") {
                      setSelectedPageMsg("This page is already being used as a rotation page.");
                  }else if(item.pageClass === "page discarded_by_cron") {
                      setSelectedPageMsg("This page has been discarded automatically by the system.");
                  }else if(item.marge_img === "img/merged-icon.png") {
                      setSelectedPageMsg("You can't set up a test on a merged page.");
                  }else {
                      handleThumbnailClick(item.page_id, item.taguchi_test_id, item.funnel_id, item.tests_id, item.pageClass);
                  }
                }}
              >
            <span title={item.page_url}>
              <span className="page-url">{item.page_title}</span>
            </span>
            <div className="thumbnail" style={{ backgroundImage: `url(${'https://static.visiopt.com/page-thumb/'+item.img_url})` }} title={item.page_url}>
              {(item.marge_img !== '' && (
                  <Image
                  id="merge_img"
                  src={item.marge_img}
                  title="This Page is merged with other links"
                />
                ))
              }
              {(item.track_check !== '' && (
                <Image
                  id="track_img"
                  src={item.track_check}
                  title={item.track_check_title}
                />
                ))
              }
            </div>
            <span className="page-title">{item.custom_title}</span>
          </div>
        </div>
      ))} 
    </>
  );
}